// extracted by mini-css-extract-plugin
export default {"root":"select_root__EkQ1Z"};